import createReport from 'docxtemplater';
import Docxtemplater from 'docxtemplater';
export default {

 Numero(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}      ,    
ObtenerDetalle0(campos)
{
    var numero= function numero(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }       
    var cero=0;
    var financiar= (+campos.total-(+campos.enganche)).toFixed(2);
    var mensualidad = (financiar/(+campos.pagos)).toFixed(2);
    var inicial=+campos.total.toFixed(2)
    var detalle=[]
    inicial=inicial.toFixed(2);
    detalle.push({numero:0,inicial:numero(inicial),pago:cero.toFixed(2),pago_interes:cero.toFixed(2) ,capital:campos.enganche.toFixed(2),saldo:financiar})
    inicial=+financiar;
    
    inicial=inicial.toFixed(2);
    var saldo= financiar;
    for(var i= 1;i<campos.pagos;i++)
    {
        saldo = (inicial-mensualidad).toFixed(2);
        detalle.push({numero:i,inicial:numero(inicial),pago:numero(mensualidad),pago_interes:cero.toFixed(2),capital:numero(mensualidad),saldo:numero(saldo)})
        inicial=(inicial-mensualidad).toFixed(2);
        
    }
    detalle.push({numero:campos.pagos,pago_interes:cero.toFixed(2),inicial:numero(inicial),pago:saldo,capital:saldo,saldo:cero.toFixed(2)})  
    return {financiar:financiar,mensualidad:mensualidad,detalle, detalle}
},
ObtenerDetalle(campos)
{
    var numero= function numero(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }       
    var cero=0;
    var financiar= (+campos.total-(+campos.enganche)).toFixed(2);
    //var mensualidad = (financiar/(+campos.pagos)).toFixed(2);
    var inicial=+campos.total.toFixed(2)
    var detalle=[]
    inicial=inicial.toFixed(2);
    detalle.push({numero:0,inicial:numero(inicial),pago:cero.toFixed(2),pago_interes:cero.toFixed(2) ,capital:campos.enganche.toFixed(2),saldo:financiar})
    inicial=+financiar;
    
    var interes=0;
    //inicial=inicial.toFixed(2);
    var cuotaFija=Math.round((inicial*(campos.interes/100)/(1-1/Math.pow((1+(campos.interes/100)),campos.pagos)))* 100) / 100
    var saldo= cuotaFija;
    for(var i= 1;i<campos.pagos;i++)
    {
        interes =Math.round((inicial*(campos.interes/100))* 100) / 100;
        saldo = Math.round((inicial-cuotaFija+interes)* 100) / 100
        detalle.push({numero:i,inicial:numero((+inicial).toFixed(2)),pago:numero(cuotaFija.toFixed(2)),pago_interes:numero(interes.toFixed(2)),capital:numero((cuotaFija-interes).toFixed(2)),saldo:numero(saldo)})
        inicial=(inicial-cuotaFija+interes).toFixed(2);
        
    }
    detalle.push({numero:campos.pagos,pago_interes:(cuotaFija-inicial).toFixed(2),inicial:numero(inicial),pago:cuotaFija,capital:(+inicial).toFixed(2),saldo:cero.toFixed(2)})  
    return {financiar:financiar,mensualidad:cuotaFija,detalle, detalle}
},
generate() {
    var docs = document.getElementById('doc');

    var reader = new FileReader();
    if (docs.files.length === 0) {
        alert("No files selected")
    }
    reader.readAsBinaryString(docs.files.item(0));

    reader.onerror = function (evt) {
        console.log("error reading file", evt);
        alert("error reading file" + evt)
    }
    reader.onload = function (evt) {
        const content = evt.target.result;
        console.log(typeof content)
        var zip = new PizZip(content);
        
        var doc;
            try {
               
             doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
            } catch(error) {
                // Catch compilation errors (errors caused by the compilation of the template : misplaced tags)
                errorHandler(error);
            }

            doc.setData({
  "title": "Default title",
  "products": [
    {
      "title": "Duk",
      "name": "DukSoftware",
      "reference": "DS0"
    },
    {
      "title": "Tingerloo",
      "name": "Tingerlee",
      "reference": "T00"
    }
  ]
}
);
            try {
                // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                doc.render();
            }
            catch (error) {
                // Catch rendering errors (errors relating to the rendering of the template : angularParser throws an error)
                errorHandler(error);
            }

            var out=doc.getZip().generate({
                type:"blob",
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            }) //Output the document using Data-URI
            saveAs(out,"output.docx")

    }
},
loadFile(url, callback) {
            PizZipUtils.getBinaryContent(url, callback);
        },

 generateURL(campos,url) {
    var ObtenerDetalle0=this.ObtenerDetalle0
    var ObtenerDetalle=this.ObtenerDetalle
            this.loadFile(
                url,
                function (error, content) {
                    if (error) {
                        throw error;
                    }
                    console.log (content)
                    var zip = new PizZip(content);
                     var doc;
            try {
               
             doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
            } catch(error) {
                // Catch compilation errors (errors caused by the compilation of the template : misplaced tags)
                errorHandler(error);
            }
        
var tabla= null
if(campos.interes==0)
{
    tabla= ObtenerDetalle0(campos);
}else
{
     tabla= ObtenerDetalle(campos);
}




var fecha =  new Date(Date.now());
var fechaActual= fecha.getFullYear().toString()+"/"+("0"+(fecha.getMonth() + 1).toString()).slice(-2)+"/"+("0"+(fecha.getDate().toString())).slice(-2);

            doc.setData({
  "cliente": campos.cliente,
  "total": campos.total,
  "enganche": campos.enganche,
  "pagos": campos.pagos,
  "financiar":tabla.financiar,
  "interes":campos.interes,
  "mensualidad":tabla.mensualidad,
  "detalle":tabla.detalle,
  "fecha":fechaActual,
 "contador":campos.numero, "cliente":campos.cliente, "vendedor":campos.vendedor, "vigencia":campos.vigencia,
 "cantidad":campos.cantidad, "unidad":campos.unidad, "descripcion":campos.descripcion, "unitario":campos.unitario,
 "condicion1":campos.condicion1, "condicion2":campos.condicion2, "pie1":campos.pie1, "pie2":campos.pie2, "pie3":campos.pie3, "pie4":campos.pie4
}
);
            try {
                // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                doc.render();
            }
            catch (error) {
                // Catch rendering errors (errors relating to the rendering of the template : angularParser throws an error)
                errorHandler(error);
            }

            var out=doc.getZip().generate({
                type:"blob",
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            }) //Output the document using Data-URI
            saveAs(out,"cotizacion.docx")

                }
            );
        },       
        
        
     generateLocal(campos,docs) {
    var ObtenerDetalle0=this.ObtenerDetalle0
    var ObtenerDetalle=this.ObtenerDetalle
    
    console.log(docs)
    
     var reader = new FileReader();
    if (docs.files.length === 0) {
        alert("No files selected");
    }
    reader.readAsBinaryString(docs.files.item(0));

    reader.onerror = function (evt) {
        console.log("error reading file", evt);
        alert("error reading file" + evt);
    };
    
    reader.onload = function (evt) {
        const content = evt.target.result;
        var zip = new PizZip(content);
    
                     var doc;
            try {
               
             doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
            } catch(error) {
                // Catch compilation errors (errors caused by the compilation of the template : misplaced tags)
                errorHandler(error);
            }
        
var tabla= null
if(campos.interes==0)
{
    tabla= ObtenerDetalle0(campos);
}else
{
     tabla= ObtenerDetalle(campos);
}




var fecha =  new Date(Date.now());
var fechaActual= fecha.getFullYear().toString()+"/"+("0"+(fecha.getMonth() + 1).toString()).slice(-2)+"/"+("0"+(fecha.getDate().toString())).slice(-2);

            doc.setData({
  "cliente": campos.cliente,
  "total": campos.total,
  "enganche": campos.enganche,
  "pagos": campos.pagos,
  "interes":campos.interes,
  "financiar":tabla.financiar,
  "mensualidad":tabla.mensualidad,
  "detalle":tabla.detalle,
  "fecha":fechaActual,
 "contador":campos.numero, "cliente":campos.cliente, "vendedor":campos.vendedor, "vigencia":campos.vigencia,
 "cantidad":campos.cantidad, "unidad":campos.unidad, "descripcion":campos.descripcion, "unitario":campos.unitario,
 "condicion1":campos.condicion1, "condicion2":campos.condicion2, "pie1":campos.pie1, "pie2":campos.pie2, "pie3":campos.pie3, "pie4":campos.pie4
}
);
            try {
                // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                doc.render();
            }
            catch (error) {
                // Catch rendering errors (errors relating to the rendering of the template : angularParser throws an error)
                errorHandler(error);
            }

            var out=doc.getZip().generate({
                type:"blob",
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            }) //Output the document using Data-URI
            saveAs(out,"cotizacion.docx")

                }
           
        },
generate32() {
    var request = new XMLHttpRequest();
request.open('GET', 'http://34.216.214.117:8080/cot.docx', true);
request.responseType = 'blob';
request.onload = function() {
    var reader = new FileReader();
    reader.readAsDataURL(request.response);
    
    reader.onerror = function (evt) {
        console.log("error reading file", evt);
        alert("error reading file" + evt)
    }
    reader.onload = function (evt) {
        const content = evt.target.result;
        var x=window.btoa(unescape(encodeURIComponent( content )));
       console.log (typeof content)
        var zip = new PizZip(btoa(content));
        
        var doc;
            try {
               
             doc = new Docxtemplater(zip, {
                paragraphLoop: true,
                linebreaks: true,
            });
            } catch(error) {
                // Catch compilation errors (errors caused by the compilation of the template : misplaced tags)
                errorHandler(error);
            }

            doc.setData({
  "title": "Default title",
  "products": [
    {
      "title": "Duk",
      "name": "DukSoftware",
      "reference": "DS0"
    },
    {
      "title": "Tingerloo",
      "name": "Tingerlee",
      "reference": "T00"
    }
  ]
}
);
            try {
                // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
                doc.render();
            }
            catch (error) {
                // Catch rendering errors (errors relating to the rendering of the template : angularParser throws an error)
                errorHandler(error);
            }

            var out=doc.getZip().generate({
                type:"blob",
                mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            }) //Output the document using Data-URI
            saveAs(out,"output.docx")

    }
}
request.send();
}
}